import type { NavSection as NavSectionType } from '@/types/navigation';
import { NavItem } from './NavItem';

/**
 * Composant NavSection pour organiser les éléments de navigation
 * Gère l'affichage des sections et leurs éléments
 */

interface NavSectionProps {
  section: NavSectionType;
  activeItemId: string | null;
  onItemClick: (itemId: string) => void;
}

export function NavSection({ section, activeItemId, onItemClick }: NavSectionProps) {
  const { title, items } = section;

  return (
    <nav className="flex flex-col gap-1 w-full" role="navigation" aria-label={title}>
      <h3
        className="text-sm font-medium leading-5 opacity-70 text-zinc-700 overflow-hidden text-ellipsis w-full"
        id={`nav-section-${section.id}`}
      >
        {title}
      </h3>
      <div
        className="flex flex-col gap-0"
        role="menu"
        aria-labelledby={`nav-section-${section.id}`}
      >
        {items.map((item) => (
          <NavItem
            key={item.id}
            item={item}
            isActive={activeItemId === item.id}
            onClick={onItemClick}
          />
        ))}
      </div>
    </nav>
  );
}
